var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitor = function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.53 2.988a2.483 2.483 0 0 1 2.482 2.483v9.41a2.483 2.483 0 0 1-2.483 2.483H12.6v2.566h3.165a.6.6 0 1 1 0 1.199h-7.53a.6.6 0 0 1 0-1.2H11.4v-2.565H4.471a2.483 2.483 0 0 1-2.483-2.482V5.47a2.48 2.48 0 0 1 2.483-2.483zm-15.06 1.2c-.708 0-1.282.574-1.282 1.283v9.41c0 .71.574 1.284 1.283 1.284h15.058c.708 0 1.282-.575 1.282-1.283V5.47c0-.708-.574-1.283-1.282-1.283z"
  })));
};
export default SvgMonitor;